(() => {
  if (window.SSReviewRotation) return;
  window.SSReviewRotation = (cards, placement) => {
    const shuffled = cards.slice();
    for (let i = shuffled.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
    }
    const key = 'ss-review-last-v1:' + location.pathname + ':' + placement;
    let previous = '';
    try { previous = localStorage.getItem(key) || ''; } catch (_) {
      try { previous = sessionStorage.getItem(key) || ''; } catch (_) {}
    }
    if (shuffled.length > 1 && shuffled[0].dataset.ssReviewId === previous) {
      const replacement = 1 + Math.floor(Math.random() * (shuffled.length - 1));
      [shuffled[0], shuffled[replacement]] = [shuffled[replacement], shuffled[0]];
    }
    if (shuffled.length) {
      const id = shuffled[0].dataset.ssReviewId;
      try { localStorage.setItem(key, id); } catch (_) {
        try { sessionStorage.setItem(key, id); } catch (_) {}
      }
    }
    return shuffled;
  };
})();

(() => {
  'use strict';
  const active = new WeakMap();
  function initialise(root) {
    if (active.has(root)) return;
    const track = root.querySelector('[data-ss-review-track]');
    const controls = root.querySelector('[data-ss-review-controls]');
    const previous = root.querySelector('[data-ss-review-prev]');
    const next = root.querySelector('[data-ss-review-next]');
    const status = root.querySelector('[data-ss-review-status]');
    if (!track || !controls || !previous || !next || !status) return;
    const cards = window.SSReviewRotation(Array.from(track.children).filter(card => card.matches('.ss-review')), 'carousel');
    track.style.overflowAnchor = 'none';
    cards.forEach(card => track.appendChild(card));
    track.scrollLeft = 0;
    if (!cards.length) { root.hidden = true; return; }
    cards.forEach((card, index) => {
      card.setAttribute('role', 'group');
      card.setAttribute('aria-roledescription', 'slide');
      card.setAttribute('aria-label', `Review ${index + 1} of ${cards.length}`);
    });
    const listeners = new AbortController();
    const signal = listeners.signal;
    let debounce, frame;
    let selected = 0;
    const visibleCount = () => Math.max(1, Number.parseInt(getComputedStyle(track).getPropertyValue('--ss-review-columns'), 10) || 1);
    const step = () => cards[0].getBoundingClientRect().width + (Number.parseFloat(getComputedStyle(track).columnGap) || 0);
    const maximum = () => Math.max(0, cards.length - visibleCount());
    const current = () => Math.min(maximum(), Math.max(0, Math.round(track.scrollLeft / Math.max(1, step()))));
    function update() {
      selected = current();
      const end = Math.min(cards.length, selected + visibleCount());
      const label = end === selected + 1 ? `Review ${selected + 1} of ${cards.length}` : `Reviews ${selected + 1} to ${end} of ${cards.length}`;
      if (status.textContent !== label) status.textContent = label;
      previous.disabled = selected === 0;
      next.disabled = selected >= maximum();
      controls.hidden = cards.length <= visibleCount();
    }
    function move(index, immediate = false) {
      selected = Math.min(maximum(), Math.max(0, index));
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      track.scrollTo({left: selected * step(), behavior: immediate || reduced ? 'auto' : 'smooth'});
      window.clearTimeout(debounce);
      debounce = window.setTimeout(update, immediate ? 0 : 450);
    }
    previous.addEventListener('click', () => move(current() - visibleCount()), {signal});
    next.addEventListener('click', () => move(current() + visibleCount()), {signal});
    track.addEventListener('scroll', () => { window.clearTimeout(debounce); debounce = window.setTimeout(update, 120); }, {passive: true, signal});
    track.addEventListener('keydown', event => {
      if (event.target !== track) return;
      const actions = {ArrowRight: () => move(current() + 1), ArrowLeft: () => move(current() - 1), Home: () => move(0), End: () => move(maximum())};
      if (actions[event.key]) { event.preventDefault(); actions[event.key](); }
    }, {signal});
    track.addEventListener('focusin', event => {
      const card = event.target.closest('.ss-review');
      if (!card) return;
      const index = cards.indexOf(card), first = current();
      if (index < first || index >= first + visibleCount()) move(index, true);
    }, {signal});
    function resized() { cancelAnimationFrame(frame); frame = requestAnimationFrame(() => move(selected, true)); }
    const observer = 'ResizeObserver' in window ? new ResizeObserver(resized) : null;
    if (observer) observer.observe(track); else window.addEventListener('resize', resized, {signal});
    update();
    active.set(root, () => { listeners.abort(); if (observer) observer.disconnect(); clearTimeout(debounce); cancelAnimationFrame(frame); active.delete(root); });
  }
  const start = scope => scope.querySelectorAll('[data-ss-review-carousel]').forEach(initialise);
  start(document);
  document.addEventListener('shopify:section:load', event => start(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-ss-review-carousel]').forEach(root => { const cleanup = active.get(root); if (cleanup) cleanup(); }));
})();


(() => {
  const selected = new Map();
  function start(scope) {
    scope.querySelectorAll('[data-ss-review-spotlight]').forEach(root => {
      if (root.dataset.reviewReady === 'true') return;
      const template = root.querySelector('template');
      const host = root.querySelector('[data-ss-review-current]');
      if (!template || !host) return;
      const key = root.dataset.ssReviewSpotlight || 'spotlight';
      if (!selected.has(key)) {
        const cards = Array.from(template.content.querySelectorAll('.ss-review'));
        selected.set(key, window.SSReviewRotation(cards, key)[0]);
      }
      const card = selected.get(key);
      if (card) host.replaceChildren(card.cloneNode(true));
      root.dataset.reviewReady = 'true';
    });
  }
  start(document);
  document.addEventListener('shopify:section:load', event => start(event.target));
})();
